import decode from 'jwt-decode';
export const jwtDecode = (token, opts) => {
    // @ts-ignore
    return decode(token, opts);
};
export function getTokenExpirationDate(token) {
    try {
        const decoded = jwtDecode(token);
        if (typeof decoded.exp === 'undefined')
            return null;
        // The 0 here is the key, which sets the date to the epoch
        const d = new Date(0);
        d.setUTCSeconds(decoded.exp);
        return d;
    }
    catch (e) {
        return null;
    }
}
export function isTokenExpired(token, offsetSeconds = 0) {
    const d = getTokenExpirationDate(token);
    if (d instanceof Date) {
        // Token expired?
        return !(d.valueOf() > new Date().valueOf() + offsetSeconds * 1000);
    }
    return false;
}
